<template>
    <div>
        <div class="leaves_top"></div>

        <HeaderMenu_Site />
        <LateralMenu_Site />

        <div class="page-content" id="contact">
            <div class="logo"></div>
            <div class="habillage-header"></div>

            <div id="header" class="content">
                <div>
                    <div class="bandeau">
                        <span>- Nous contacter -</span>
                        <div>
                            <div class="bandeau-wordings">
                                Une question ? Avez-vous consulté notre <a href="/contact#faq">F.A.Q.</a> ?
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="form" class="content">
                <div class="column left">
                    <div>
                        <span>Votre message</span>
                        <div>
                            <span>Type de contact *</span>
                            <select id="field_contactType" name="field_contactType" v-model="form_contactType">
                                <option value="Entreprise">Entreprise</option>
                                <option value="Particulier">Particulier</option>
                                <option value="Collectivité">Collectivité</option>
                                <option value="Presse">Presse</option>
                            </select>
                        </div>
                        <div class="multiple">
                            <div>
                                <span>Email *</span>
                                <input type="text" id="field_email" name="field_email" v-model="form_email" />
                            </div><!--
                            --><div>
                                <span>Société (facultatif)</span>
                                <input type="text" id="field_company" name="field_company" v-model="form_company" />
                            </div>
                        </div>
                        <div class="multiple">
                            <div>
                                <span>Nom et prénom *</span>
                                <input type="text" id="field_fullName" name="field_fullName" v-model="form_fullName" />
                            </div><!--
                            --><div>
                                <span>Téléphone *</span>
                                <input type="text" id="field_phoneNumber" name="field_phoneNumber" v-model="form_phoneNumber" />
                            </div>
                        </div>
                        <div>
                            <span>Votre message *</span>
                            <textarea id="field_message" name="field_message" v-model="form_message">Un beau message</textarea>
                        </div>

                        <div class="button-container">
                            <button v-on:click="button_sendEmail_onClick" v-bind:disabled="isLoading" v-if="!isLoading">Envoyer</button>
                        </div>
                    </div>
                </div>

                <div class="column right">
                    <div>
                        <span>Contact</span>
                        <div>
                            <span>07 82 42 47 16</span>
                            <span>lockquest.escape@gmail.com</span>
                        </div>
                        <div>
                            <span class="bold">Lock Quest®</span>
                            <span>6 chemin de Lamballard</span>
                            <span>14760 Bretteville-sur-Odon</span>
                        </div>
                    </div>
                </div>
            </div>

            <div id="faq" class="content">
                <div class="column left">
                    <ul>
                        <li v-bind:class="{ active: currentIndex == 1 }" v-on:click="update_faq_block(1)">Combien de personnes ?</li>
                        <li v-bind:class="{ active: currentIndex == 2 }" v-on:click="update_faq_block(2)">Désistement / ajout d'une personne</li>
                        <li v-bind:class="{ active: currentIndex == 3 }" v-on:click="update_faq_block(3)">Utilisation des bons cadeau</li>
                        <li v-bind:class="{ active: currentIndex == 4 }" v-on:click="update_faq_block(4)">Âge des participants</li>
                        <li v-bind:class="{ active: currentIndex == 5 }" v-on:click="update_faq_block(5)">Accès P.M.R.</li>
                        <li v-bind:class="{ active: currentIndex == 6 }" v-on:click="update_faq_block(6)">Durée du jeu / temps de présence</li>
                        <li v-bind:class="{ active: currentIndex == 7 }" v-on:click="update_faq_block(7)">Offres groupes / entreprises</li>
                        <li v-bind:class="{ active: currentIndex == 8 }" v-on:click="update_faq_block(8)">Anniversaires, EVC, personnalisation</li>
                        <li v-bind:class="{ active: currentIndex == 9 }" v-on:click="update_faq_block(9)">Comment réserver ?</li>
                    </ul>
                </div>

                <div class="column right">
                    <div>
                            <div v-if="currentIndex == 0">
                                <span>Questions fréquentes</span>
                                <span class="italic">Choisissez votre question dans la liste</span>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <span>
                                    Vous n'avez pas trouvé votre réponse ?
                                    <br />Contactez-nous <span class="italic">via</span> le formulaire ci-dessus ou
                                    <br />directement au
                                    <br />07 82 42 47 16
                                </span>
                            </div>
                            <div v-if="currentIndex == 1">
                                <span>Combien de personnes ?</span>
                                <span>
                                    Nos Escape Game sont conçus pour des équipes de 2 à 5 personnes. 
                                    Pour des groupes de 6 joueurs, nous pouvons accueillir une personne supplémentaire (23€) 
                                    bien que ce ne soit pas idéal pour le déroulement du jeu. 
                                    Pour les groupes plus importants, vous devrez réserver plusieurs salles avec un départ simultané.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Nos <a href="https://www.padquest.fr" target="_blank">jeux de piste en plein air</a> sont conçus pour des équipes de 2 à 6 joueurs, 
                                    6 équipes peuvent s’affronter simultanément pour un total de 36 participants. 
                                    Pour des groupes plus importants, contactez-nous pour nos solutions adaptées.
                                </span>
                            </div>
                            <div v-if="currentIndex == 2">
                                <span>Désistement / ajout d'une personne</span>
                                <span>
                                    Lock Quest® est une activité live, aucun désistement ne sera accepté.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    <span class="bold">Un joueur de dernière minute ?</span>
                                    <br />Il sera bien sûr accepté dans la mesure où votre groupe ne dépasse pas 5 joueurs. 
                                    Selon le nombre de personnes final dans votre équipe, le complément de paiement vous sera demandé sur place 
                                    <span class="bold">par chèque, espèces ou CB</span>.
                                </span>
                            </div>
                            <div v-if="currentIndex == 3">
                                <span>Utilisation des bons cadeau</span>
                                <span>
                                    Indiquez simplement le montant de vos bons cadeau dans le formulaire lors de votre inscription. 
                                    Ce montant sera automatiquement déduit. 
                                    Pensez à apporter votre bon imprimé le jour de votre escape game, ou le montant vous sera réclamé.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Attention, si le montant des bons est supérieur à celui de votre réservation, 
                                    la différence ne pourra pas vous être remboursée.
                                </span>
                            </div>
                            <div v-if="currentIndex == 4">
                                <span>Âge des participants</span>
                                <span>
                                    L’âge minimum conseillé pour participer à nos aventures est d'environ 10 ans.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Cet âge minimum est recommandé à cause de la difficulté des énigmes et des défis proposés. 
                                    Nos Escape Game ne contiennent pas d’éléments susceptibles de choquer les plus jeunes.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Les équipes contenant un ou plusieurs mineurs de moins de 15 ans devront obligatoirement inclure un adulte.
                                </span>
                            </div>
                            <div v-if="currentIndex == 5">
                                <span>Accès P.M.R.</span>
                                <span>
                                    Un escape game nécessitant des déplacements et un travail de fouille, 
                                    il est possible que certains passages ne soient pas réalisables par les P.M.R. 
                                    Une solution alternative vous sera proposée.
                                    <p>&nbsp;</p>
                                    Contactez-nous pour plus de détails au cas par cas.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Etant donné l’exiguité des lieux, nous limitons l’accès aux fauteuils roulants à 2 par salle. 
                                    Une personne valide doit également être présente dans l’équipe.
                                </span>
                            </div>
                            <div v-if="currentIndex == 6">
                                <span>Durée du jeu<br />Temps de présence</span>
                                <span>
                                    Entre votre accueil, les explications, la durée du jeu, le debrief, il faudra prévoir 1h30 sur place.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Par exemple, pour une inscription à 18h30, votre aventure se terminera vers 20h.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Pour ne pas retarder les autres groupes, nous vous recommandons de vous présenter 10 min avant votre heure d’inscription.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Attention, tout retard sera décompté de votre temps de jeu dans la salle !
                                </span>
                            </div>
                            <div v-if="currentIndex == 7">
                                <span>Offres groupes<br />entreprises</span>
                                <span>
                                    Consultez notre <a href="/entreprises">page dédiée</a> pour découvrir nos offres entreprises.
                                </span>
                            </div>
                            <div v-if="currentIndex == 8">
                                <span>Anniversaires / EVC</span>
                                <span>
                                    Rendez cet instant unique avec une touche de personnalisation.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Fournissez-nous des photos, des informations sur l’événement à fêter, 
                                    et nos Game Master se chargeront de concocter quelques surprises personnalisées à votre aventure.
                                </span>
                            </div>
                            <div v-if="currentIndex == 9">
                                <span>Comment réserver ?</span>
                                <span>
                                    <span class="bold">Escape Game</span>
                                    <br />Allez sur la <a href="/nos-scenarios-escape-caen">page des énigmes</a> puis cliquez sur le bouton “Réserver” de l’Escape Game souhaitée. 
                                    Cliquez sur l’horaire et le nombre de personnes souhaité. 
                                    Renseignez vos coordonnées dans le formulaire. Procédez au paiement.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    <span class="bold">Jeux de piste en plein air</span>
                                    <br />Les réservations se font en ligne sur le <a href="https://www.padquest.fr" target="_blank">site dédié</a>.
                                </span>
                                <p>&nbsp;</p>
                                <span>
                                    Toutes nos réservations se font en ligne, aucun paiement sur place ne sera accepté.
                                </span>
                            </div>
                        </div>
                    
                </div>
            </div>
        </div>

        <div id="leaves_sides">
            <div class="left"></div>
            <div class="right"></div>
        </div>

        <Footer
            seo_contentH1="Lock Quest escape game Caen - Nous contacter et foire aux questions"
            seo_contentH2="Une question ? Avez-vous consulté notre FAQ ? Un devis, une facture" />
    </div>
</template>

<script>
import HeaderMenu_Site from '../../components/HeaderMenu_Site.vue';
import LateralMenu_Site from '../../components/LateralMenu_Site.vue';
import Footer from '../../components/Footer.vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

export default {
    name: "Site_ContactPage",
    components: {
        HeaderMenu_Site,
        LateralMenu_Site,
        Footer
    },
    data: function() {
        return {
            currentIndex: 0,
            form_contactType: '',
            form_email: '',
            form_company: '',
            form_fullName: '',
            form_phoneNumber: '',
            form_message: '',
            isLoading: false
        }
    },
    methods: {
        update_faq_block: function(index) {
            this.currentIndex = index;
        },
        button_sendEmail_onClick: function(event) {
            if (this.form_contactType == '' || this.form_email == '' || this.form_fullName == '' 
                || this.form_phoneNumber == '' || this.form_message == '') {
                    alert('Tous les champs obligatoires du formulaire n\'ont pas été remplis.');
                    return;
                }

            this.isLoading = true;

            axios.post('https://api.lockquest.fr/contact', {
                form_contactType: this.form_contactType,
                form_email: this.form_email,
                form_company: this.form_company,
                form_fullName: this.form_fullName,
                form_phoneNumber: this.form_phoneNumber,
                form_message: this.form_message
            }, { 
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((response) => {
                this.isLoading = false;
			    alert('Votre message a été envoyé. Nous vous répondrons dans les plus brefs délais.');
            }).catch((error) => {
                this.isLoading = false;
                alert('Une erreur est survenue. Veuillez essayer à nouveau ultérieurement.');
            });
        }
    }
}
</script>